import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const FAQAccordion = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section className="py-10 max-w-5xl mx-auto px-6">
      <div className="text-left mb-7">
        <span className="text-red-tagline block mb-2 text-tiny">Knowledge Base</span>
        <h2 className="text-3xl font-black text-primary">FAQ & Answers</h2>
      </div>
      
      <div className="space-y-3">
        {faqs.map((faq, i) => {
          const isOpen = activeIndex === i;
          
          return (
            <div 
              key={i} 
              className={`bg-white border transition-all duration-300 rounded-xl overflow-hidden ${
                isOpen ? 'border-secondary/30 shadow-sm' : 'border-slate-200'
              }`}
            >
              <button
                onClick={() => setActiveIndex(isOpen ? null : i)}
                className="w-full text-left p-4 lg:p-5 flex gap-4 items-center focus:outline-none group"
              >
                <span className={`flex-1 font-black text-[17px] transition-colors ${isOpen ? 'text-primary' : 'text-slate-700 group-hover:text-secondary'}`}>
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 text-slate-400 transform transition-transform duration-300 ${isOpen ? 'rotate-180 text-secondary' : ''}`} />
              </button>
 
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                  >
                    <div className="px-4 lg:px-5 pb-5 pt-0">
                      <p className="text-slate-600 text-tiny leading-relaxed border-l-2 border-secondary/20 pl-4">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQAccordion;
